import type { TherapistType } from '@/legacy-src/types/TherapistStateType'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import Bubble from '../../Bubble'
import { TherapistsPreviewInRegistrationTitle } from './TherapistsPreviewInRegistrationTitle'

export interface TherapistsPreviewInRegistrationOriginalProps {
  therapist: TherapistType
  nameVocative?: string
}

export const TherapistsPreviewInRegistrationOriginal = ({
  therapist,
  nameVocative,
}: TherapistsPreviewInRegistrationOriginalProps) => {
  const { t } = getTranslate()

  return (
    <div className="mb-6">
      <div className="flex flex-col items-center justify-center">
        <div className="my-6 flex items-center">
          <Bubble
            imgUrl={therapist.image ?? '/images/svg/misc/therapist-placeholder.svg'}
            sizeClass="w-20 h-20"
            className="mr-6 inline-block shrink-0"
          />
          <TherapistsPreviewInRegistrationTitle nameVocative={nameVocative} />
        </div>
        <strong>{t('diagnosisTest.register.description.default')}</strong>
      </div>
    </div>
  )
}
